import { useMemo } from 'react';
import Label from 'react-rainbow-components/components/Input/label';
import ListTile from 'components/ListTile';
import UserAvatar from 'components/UserAvatar';
import getDisplayName from 'data/services/profile/getDisplayName';
import getInitials from 'data/services/string/getInitials';
import { InnerContainer, StyledChip, ValueContainer } from './styled';

interface Params {
    id?: string;
    className?: string;
    label?: string;
    required?: boolean;
    value: any;
    onClearValue?: () => void;
    hideLabel?: boolean;
    variant?: 'default' | 'inline';
}

const SelectedValue = ({
    id,
    className,
    label,
    required = false,
    value,
    onClearValue = () => {},
    hideLabel = false,
    variant = 'default',
}: Params) => {
    const displayName = useMemo(() => getDisplayName(value), [value]);

    const initials = useMemo(() => (
        displayName === 'Unknown'
            ? null
            : getInitials(displayName)
    ), [displayName]);

    return (
        <ValueContainer id={id} className={className}>
            <Label
                label={label}
                labelAlignment="left"
                required={required}
                hideLabel={hideLabel}
            />
            <InnerContainer>
                <StyledChip
                    label={(
                        <ListTile
                            icon={(
                                <UserAvatar
                                    initials={initials}
                                    value={value.id}
                                    src={value.photoURL}
                                    size={variant === 'inline' ? 'x-small' : 'medium'}
                                />
                            )}
                            title={displayName}
                            subtitle={variant === 'default' ? value.email : undefined}
                            $variant={variant}
                        />
                    )}
                    borderRadius="semi-square"
                    onDelete={onClearValue}
                    $variant={variant}
                />
            </InnerContainer>
        </ValueContainer>
    );
};

export default SelectedValue;
